import { render, staticRenderFns } from "./RecipeInstructions.vue?vue&type=template&id=dbd2eec0"
import script from "./RecipeInstructions.vue?vue&type=script&lang=js"
export * from "./RecipeInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports